import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  bar: {
    width: "100%",
    position: "absolute",
    bottom: 0,
    backgroundColor: "black",
    height: 40,
    flexDirection: "row",
    paddingHorizontal: "7vw",
    alignItems: "center",
    elevation: 5,
  },
  message: {
    color: "white",
    paddingHorizontal: "3vw",
    fontSize: "$h3",
    fontWeight: "bold",
  },
});
